const searchParams = new URLSearchParams(window.location.search);

export const periods = {
  "Este mês": "currentMonth",
  Hoje: "today",
  "Mês Anterior": "lastMonth",
  "Próximo Mês": "nextMonth",
  "Este Ano": "currentYear",
  "Este Trimestre": "quarter",
  Personalizado: "custom",
};

export const movimentsTypes = {
  "Contas a Pagar": "pay",
  "Contas a Receber": "receive",
  Todos: "all",
};

export const reportTypes = {
  Detalhado: "detailed",
  Consolidado: "consolidated",
};

export const groupOptions = {
  Diario: "day",
  Semanal: "week",
  Mensal: "month",
};

export const xlsxGroupEmptyDescription = {
  date: "Sem data",

  name: "Sem descrição",

  situation: "Sem situação",
};

export const initialFilters = {
  period: periods["Este mês"],
  startDate: undefined,
  endDate: undefined,
  moviment: movimentsTypes.Todos,
  multicompany: Number(searchParams.get("empresa_id")),
  reportType: reportTypes.Detalhado,
  group: groupOptions.Diario,
  showPreviousBalance: false,
  useFinanceCategories: false,
  showNotPayedAccounts: false,
  showNotReceivedTitles: false,
};

export const orientationOptions = {
  Retrato: "RETRATO",
  Paisagem: "PAISAGEM",
};

export const orientationLabelOptions = {
  Retrato: "Retrato",
  Paisagem: "Paisagem",
};
